import { Injectable } from '@angular/core';

import { ReBetConfig } from '@frontend/sports/common/client-config-data-access';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { ReBetMyBetsTabs } from '../../../common/re-bet-my-bets-tabs.models';

@Injectable()
export class ReBetAvailabilityService {
    constructor(private reBetConfig: ReBetConfig) {}

    isAvailable(listType?: BetslipListType): boolean {
        const tab = this.getTabFromListType(listType);

        return this.reBetConfig.enabledTabs.includes(tab.toUpperCase());
    }

    isCTASubTextAvailable(listType?: BetslipListType): boolean {
        const tab = this.getTabFromListType(listType);

        return this.reBetConfig.ctaSubtitleEnabledTabs.includes(tab.toUpperCase());
    }

    isCTASubHeaderAvailable(listType?: BetslipListType): boolean {
        const tab = this.getTabFromListType(listType);

        return this.reBetConfig.ctaDescriptionEnabledTabs.includes(tab.toUpperCase());
    }

    isHelpBoxAvailable(listType?: BetslipListType): boolean {
        const tab = this.getTabFromListType(listType);

        return this.reBetConfig.helpBoxEnabledTabs.includes(tab.toUpperCase()) && this.reBetConfig.enabledTabs.includes(tab.toUpperCase());
    }

    private getTabFromListType(listType?: BetslipListType): string {
        switch (listType) {
            case BetslipListType.Live:
                return ReBetMyBetsTabs.Live;
            case BetslipListType.Open:
                return ReBetMyBetsTabs.Open;
            case BetslipListType.Settled:
                return ReBetMyBetsTabs.Settled;
            default:
                return '';
        }
    }
}
